import { HttpClient } from '#client/http/index'
import { ApiResponse } from '#client/resources/types'
import { FetchAllResponse, TopMeResponse } from '#client/resources/index'

export const fetchAll = async ({ httpClient }: { httpClient: HttpClient }) => {
  const { data }: ApiResponse<FetchAllResponse> = await httpClient.get(
    `/user/top`,
    {
      headers: { 'Cache-Control': 'public' },
    },
  )
  return { data }
}

export const me = async ({ httpClient }: { httpClient: HttpClient }) => {
  const data: TopMeResponse = await httpClient.get(`/user/top/me`, {
    headers: { 'Cache-Control': 'public' },
  })
  return { data }
}
